export interface BootstrapBaselineOptions {
  includeRequirements?: boolean;
  includeChecklist?: boolean;
}

export async function bootstrapProjectBaseline(
  projectId: string,
  options: BootstrapBaselineOptions = {}
): Promise<{
  projectId: string;
  createdRequirements: number;
  skippedRequirements: number;
  createdChecklistItems: number;
  skippedChecklistItems: number;
}> {
  const response = await fetch(
    `/api/projects/${encodeURIComponent(projectId)}/bootstrap-baseline`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(options),
    }
  );

  if (!response.ok) {
    // Essaie de récupérer un message d’erreur, sinon jette un message générique
    let message = `Failed to bootstrap project baseline (HTTP ${response.status})`;
    try {
      const payload = await response.json();
      if (typeof payload?.error === "string") {
        message = payload.error;
      } else if (typeof payload?.message === "string") {
        message = payload.message;
      }
    } catch {
      // ignore JSON parse error
    }
    throw new Error(message);
  }

  return (await response.json()) as {
    projectId: string;
    createdRequirements: number;
    skippedRequirements: number;
    createdChecklistItems: number;
    skippedChecklistItems: number;
  };
}
